import React from 'react'

import { Box, useProps } from '@affstore-ds/uikit'

import { getAdvertiserLogoPath } from '../../utils'
import { AdvertiserLogoPropertiesInterface } from './AdvertiserLogo.types'

import { useAdvertiserLogoStyles } from './AdvertiserLogo.styled'

const defaultProperties: Pick<AdvertiserLogoPropertiesInterface, 'size'> = {
  size: 's',
}

export const AdvertiserLogo = (properties: AdvertiserLogoPropertiesInterface) => {
  const { alt, className, iconName, size, ...rest } = useProps('AdvertiserLogo', defaultProperties, properties)
  const { classes, cx } = useAdvertiserLogoStyles()

  if (!iconName) {
    return null
  }

  return (
    <Box
      data-testid="advertiser-logo"
      alt={alt || 'Advertiser logo'}
      className={cx(classes.root, className)}
      component="img"
      src={getAdvertiserLogoPath({ iconName, size })}
      {...rest}
    />
  )
}
